import { useEffect } from "react";
import { Reveal } from "../site/Motion";
import { SectionLabel } from "../site/Bits";
import { FAQS } from "../../lib/site";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

export const FAQ = () => {
  useEffect(() => {
    const ld = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: FAQS.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    };
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.dataset.page = "home-faq";
    script.textContent = JSON.stringify(ld);
    document.head.appendChild(script);
    return () => script.remove();
  }, []);

  return (
    <section id="faq" className="relative scroll-mt-24 bg-background py-24" data-testid="faq-section">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-14 px-5 lg:grid-cols-12 lg:px-8">
        <div className="lg:col-span-4">
          <Reveal>
            <SectionLabel>FAQ</SectionLabel>
            <h2 className="mt-5 font-display text-4xl font-bold leading-tight tracking-tight text-ink sm:text-5xl">
              Questions, answered.
            </h2>
            <p className="mt-4 text-base leading-relaxed text-slate-600">
              Everything you need to know about RenewTracker. Still curious?{" "}
              <a href="/contact" className="font-semibold text-brand underline-offset-4 hover:underline">
                Get in touch
              </a>
              .
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-8">
          <Reveal>
            <Accordion type="single" collapsible className="w-full space-y-3" data-testid="faq-accordion">
              {FAQS.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  data-testid={`faq-item-${i}`}
                  className="overflow-hidden rounded-2xl border border-slate-200 bg-white px-6"
                >
                  <AccordionTrigger className="py-5 text-left font-display text-base font-semibold text-ink hover:no-underline">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="pb-5 text-[15px] leading-relaxed text-slate-600">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
